module.exports = "/assets/images/1d7cf3b44d9192b117a21318ecff5ed1.svg";